module.exports = __webpack_public_path__ + "static/media/dribbble.2959880f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Social/dribbble.svg
// module id = 85
// module chunks = 0